import { z } from "zod";

import { zPasswordSchema } from "./password";

import { UserRoleEntity } from "~/entities/user-role/@x/user";
import { Regex } from "~/shared/zod";

const zSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  phone: z.string().superRefine(Regex.REFINEMENTS.mustMatchPhoneNumberFormat),
  username: z.string(),
  firstName: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 6),
  lastName: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 6),
  roles: z.array(UserRoleEntity.zSchema),
  password: zPasswordSchema,
});
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
